import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { parseLikertAggregateValue, guessLikertSentiment } from './helpers';

const SENTIMENT_TOKEN = {
  positive: 'success',
  negative: 'error',
  neutral: 'info',
};

const LikertAggregateChips = ({ value, maxChipWidth }) => {
  const segments = parseLikertAggregateValue(value);
  if (segments.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {segments.map((segment, index) => {
        const label = segment.statement ? `${segment.statement}: ${segment.answer}` : segment.answer;
        const token = SENTIMENT_TOKEN[guessLikertSentiment(segment.answer)];
        return (
          <Tooltip key={`likert-chip-${index}`} title={label} arrow>
            <Chip
              size="small"
              label={label}
              icon={<FiberManualRecordIcon sx={{ fontSize: '10px !important', color: `${token}.main` }} />}
              sx={{
                bgcolor: (theme) => alpha(theme.palette[token].main, 0.12),
                color: `${token}.dark`,
                border: 'none',
                maxWidth: maxChipWidth || 220,
                '& .MuiChip-label': {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
              }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default LikertAggregateChips;
